import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageNavbar from './LegalPageNavbar';
import './LandingPage.css';

const CookiePolicyPage = () => (
  <div className="landing-page">
    <LegalPageNavbar />

    <section className="section-container" style={{ paddingTop: '96px', paddingBottom: '72px' }}>
      <div className="section-content legal-document" style={{ maxWidth: 900 }}>
        <h1>Cookie Policy</h1>
        <p><strong>Last updated:</strong> June 16, 2026</p>
        <p>
          This Cookie Policy explains how <strong>Syllera</strong> (Master Languages Vocabulary by Educational
          Level with AI-powered learning) uses cookies and similar tracking technologies on our website and
          related services (the &quot;Platform&quot;). It should be read together with our{' '}
          <Link to="/privacy-policy">Privacy Policy</Link>.
        </p>

        <h2>1. What Are Cookies?</h2>
        <p>
          Cookies are small text files stored on your device when you visit a website. They help websites
          remember your preferences, keep you signed in, and understand how the site is used. We also use
          similar technologies such as local storage, session storage, and device identifiers in our mobile apps.
        </p>

        <h2>2. How Syllera Uses Cookies</h2>
        <p>We use cookies and similar technologies for the following purposes:</p>

        <h2>3. Types of Cookies We Use</h2>
        <ul>
          <li>
            <strong>Essential cookies (required):</strong> necessary for login, authentication, security, and
            core Platform functionality. These cannot be disabled without affecting how the Platform works.
          </li>
          <li>
            <strong>Preference cookies:</strong> remember your language selection, display settings, and other
            choices to personalize your experience.
          </li>
          <li>
            <strong>Analytics cookies:</strong> help us understand how users interact with the Platform (pages
            visited, features used, session duration) so we can improve performance and content.
          </li>
          <li>
            <strong>Functional cookies:</strong> support features such as live chat (e.g., Tawk.to) and
            notification preferences.
          </li>
        </ul>

        <h2>4. Third-Party Cookies</h2>
        <p>
          Some cookies are set by trusted third-party services that help us operate Syllera, including:
        </p>
        <ul>
          <li>Analytics providers (to measure usage and improve the Platform)</li>
          <li>Firebase / Google services (authentication, push notifications)</li>
          <li>Tawk.to (live chat support)</li>
          <li>Payment processors (during checkout sessions)</li>
        </ul>
        <p>
          These third parties may collect information according to their own privacy policies. We do not use
          cookies to sell your personal information or for third-party behavioral advertising targeted at students.
        </p>

        <h2>5. Managing Cookies</h2>
        <p>You can control cookies in several ways:</p>
        <ul>
          <li>
            <strong>Browser settings:</strong> most browsers let you block or delete cookies. See your browser&apos;s
            help section for instructions.
          </li>
          <li>
            <strong>Disabling cookies:</strong> blocking essential cookies may prevent you from logging in or
            using key features.
          </li>
          <li>
            <strong>Mobile apps:</strong> device settings may allow you to limit ad tracking or reset advertising
            identifiers.
          </li>
        </ul>

        <h2>6. Data Retention</h2>
        <p>
          Session cookies expire when you close your browser. Persistent cookies remain for a set period or
          until you delete them. Retention periods vary by cookie type and purpose.
        </p>

        <h2>7. Changes to This Cookie Policy</h2>
        <p>
          We may update this Cookie Policy from time to time. Material changes will be posted on this page with
          an updated &quot;Last updated&quot; date.
        </p>

        <h2>8. Contact Us</h2>
        <p>For questions about cookies or tracking on Syllera, contact:</p>
        <ul>
          <li>Email: <a href="mailto:privacy@syllera.com">privacy@syllera.com</a></li>
          <li>Support: <a href="mailto:support@syllera.com">support@syllera.com</a></li>
        </ul>
        <p>
          Related policies: <Link to="/privacy-policy">Privacy Policy</Link> ·{' '}
          <Link to="/terms-of-service">Terms of Service</Link>
        </p>
      </div>
    </section>
  </div>
);

export default CookiePolicyPage;
